import React, { Component } from "react";
import styled from "styled-components";
import antd from "antd";

import "../fonts/fonts.css";
import logoImage from "../images/logo.png";

import backgroundRed from "./background-red.svg";
import backgroundBlue from "./background-blue.svg";

const {
	Button
} = antd;

const StyledDiv = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	justify-content: space-around;
	align-items: center;
	color: white;
	background-image: url("${backgroundRed}");
	background-color: #db5b61;
	background-size: 100px;
	background-position: center;
	background-attachment: fixed;
	position: relative;
	overflow: hidden;
	&::before {
		position: absolute;
		width: calc(50% + 6.2vh);
		height: 100%;
		right: 0px;
		background-color: #3c668f;
		background-size: 100px;
		background-position: center;
		background-attachment: fixed;
		clip-path: polygon(12.4vh 0,100% 0,100% 100%,0% 100%);
		content: "";
		background-image: url("${backgroundBlue}");
	}
`;

const Logo = styled.img`
	position: absolute;
    width: 23vw;
    z-index: 2;
    filter: drop-shadow(0px 6px 12px rgba(0,0,0,0.5));
`;

const TextBlock = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 22vw;
	align-items: center;
	&.left {
		margin-left: 150px;
	}
	&.right {
		margin-right: 150px;
	}
	> h1 {
		line-height: 1;
		z-index: 1;
		font-family: "Aachen";
		margin: 0px;
	}
`;

/**
 *
 *
 * @param {number} width
 * width of border
 * @param {string} color
 * color of text
 * @returns {string}
 * css text shadow
 */
const textBorder = (width, color) => {
	const pixelString = `${width}px`;

	return "x x y, -x x y, x -x y, -x -x y".replace(/x/g, pixelString).replace(/y/g, color);
};

/**
 *
 *
 * @param {number} depth
 * depth of tower
 * @param {string} direction
 * direction of tower
 * @param {number} width
 * width of border
 * @param {string} color
 * color of text
 * @returns {string}
 * css text shadow
 */
const textTowerWithBorder = (depth, direction, width, color) => {
	let tower = "";

	switch (direction) {
		case "br":
			for (let i = 1; i < (depth + 1); i++) {
				if (i !== depth) {
					if (i < (depth - (width - 1))) {
						tower += `${i}px ${i}px ${color}, ${i - width}px ${width + i}px ${color}, ${width + i}px ${i - width}px ${color}, `;
					}
					else {
						tower += `${i}px ${i}px ${color}, `;
					}
				}
				else {
					tower += `${i}px ${i}px ${color}`;
				}
			}
			break;

		case "bl":
			for (let i = 1; i < (depth + 1); i++) {
				if (i !== depth) {
					if (i < (depth - (width - 1))) {
						tower += `${-i}px ${i}px ${color}, ${-width - i}px ${i - width}px ${color}, ${width - i}px ${width + i}px ${color}, `;
					}
					else {
						tower += `${-i}px ${i}px ${color}, `;
					}
				}
				else {
					tower += `${-i}px ${i}px ${color}`;
				}
			}
			break;

		default:
			break;
	}

	return `${textBorder(width, color)}, ${tower}`;
};

const Wn = styled.h1`
	font-size: 11.366vw;
	color: #3c668f;
	text-shadow: ${textTowerWithBorder(10, "br", 3, "white")};
`;

const Slam = styled.h1`
	font-size: 6.7vw;
	color: #3c668f;
	text-shadow: ${textTowerWithBorder(10, "br", 3, "white")};
`;

const Divider = styled.div`
	background-color: white;
	height: 120%;
    width: 100px;
    transform: rotate(8.5deg);
	display: flex;
	justify-content: center;
	> div {
		width: 20%;
    	height: 100%;
		&:first-child {
			background-color: #db5b61;
		}
		&:last-child {
			background-color: #3c668f;
		}
	}
`;

const Day = styled.h1`
	font-size: 4.57vw;
	color: #e6646a;
	text-shadow: ${textTowerWithBorder(10, "bl", 3, "white")};
`;

const Month = styled.h1`
	font-size: 10vw;
	color: #e6646a;
	text-shadow: ${textTowerWithBorder(10, "bl", 3, "white")};
`;

const Year = styled.h1`
	font-size: 7.8vw;
	color: #e6646a;
	text-shadow: ${textTowerWithBorder(10, "bl", 3, "white")};
`;

const Subline = styled.span`
	color: white;
	z-index: 1;
    position: absolute;
	font-family: "Aachen";
	bottom: 20px;
    width: 23vw;
    font-size: 1.4vw;
	&.left {
		left: 20px;
	}
	&.right {
		right: 20px;
		text-align: right;
	}
`;

/**
 *
 *
 * @class Home
 * @extends {Component}
 * @author [Nano Miratus](https://github.com/nnmrts)
 * @since 0.1.0
 * @param {object} changedFields
 * changed fields
 */
const Home = class extends Component {
	/**
	 *
	 *
	 * @returns {JSX.Element}
	 * component
	 * @memberof Home
	 * @author [Nano Miratus](https://github.com/nnmrts)
	 * @since 0.1.0
	 */
	render() {
		return (
			<StyledDiv>
				<Logo src={logoImage} />
				<TextBlock className="left">
					<Wn>WN</Wn>
					<Slam>SLAM</Slam>
				</TextBlock>
				<Divider>
					<div></div>
					<div></div>
					<div></div>
				</Divider>
				<TextBlock className="right">
					<Day>15. & 16.</Day>
					<Month>MAI</Month>
					<Year>2018</Year>
				</TextBlock>
				<Subline className="left">
					Die 3. Poetry Slam Landesmeisterschaft für Wien, Niederösterreich & Burgenland
				</Subline>
				<Subline className="right">
					Wiener Konzerthaus<br/>Lothringerstraße 20<br/>1030 Wien
				</Subline>
			</StyledDiv>
		);
	}
};

export default Home;



// WEBPACK FOOTER //
// ./src/routes/home.js